<ng-container>
  <div class="wrapper">
    <div class="container">
      <div class="new-posting-header" id="new-posting-header" aria-hidden="false">
        <h1 id="main-content-focus" class="new-posting-header__heading"
          tabindex="-1">
          {{ newPostTranslations.textPostingHeader}}
        </h1>
      </div>
      <!-- Tabs -->
      <div class="vin-post-search">
        <tabset
          #postingTabset
          type="tabs"
          [class.hide-third-party-post]="!isThirdPartyPostingEnabled">

          <tab heading="{{ newPostTranslations.textNewPostTabHeader }}" (selectTab)="activeTab = postingTabs.POST">
            <div>
              <ng-container *ngTemplateOutlet="tmplNewPost"></ng-container>
            </div>
          </tab>

          <tab heading="{{ newPostTranslations.textThirdPartyPostTabHeader}}" class="third-party-post-tab"
            (selectTab)="activeTab = postingTabs.THIRD_PARTY_POST">
            <div>
              <ng-container *ngTemplateOutlet="tmplThirdPartyPost"></ng-container>
            </div>
          </tab>
        </tabset>
      </div>

      <!-- New Post -->
      <ng-template #tmplNewPost>
        <ng-container>
          <div class="new-posting-container">
            <form [formGroup]="vinPostingForm" (ngSubmit)="decodeVin()" id="vin-posting-form" aria-hidden="false">
              @if (this.isLeadSeller) {
                <div class="input-container">
                  <div class="form-group">
                    <label for="leadSellerDealershipSelection" class="label">{{newPostTranslations.dealershipsLabel}}</label>
                    <div class="select-wrapper">
                      <select #newPostDealershipSelect formControlName="leadSellerDealershipSelection" id="leadSellerDealershipSelection" class="custom-select wrapText leadDealerSelect">
                        <option [ngValue]="'default'">{{newPostTranslations.select}}</option>
                        @for (dealership of dealershipOptions; track dealership) {
                          <option [ngValue]="dealership.oeUuid">{{dealership.oeName}}</option>
                        }
                      </select>
                    </div>
                  </div>
                  @if (this.isDealershipOptionsEmpty) {
                    <span class="required-item-error-message">
                      {{newPostTranslations.noDealershipsFoundMessage}}
                    </span>
                  }
                </div>
              }

              @if (!this.isLeadSeller || this.isLeadSellerDealerChosen(this.vinPostingForm)) {
                <div [ngClass]="this.isLeadSeller? 'input-container lead-seller-style' : 'input-container'">
                  <input
                    #vinDecodeInput
                    formControlName="vin"
                    id="post-by-vin"
                    type="text"
                    maxlength="17"
                    minLength="17"
                    placeholder="{{newPostTranslations.textVinDecodePlaceholder}}"
                    class="italic-placeholder form-control"
                    [class.invalid]="vinPostingForm.get('vin').errors"
                    aria-labelledby="post-by-vin__label"
                    aria-describedby="post-by-vin__description"
                    />
                  <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="post-by-vin__error">
                    @if (vinPostingForm.get('vin').errors) {
                      {{newPostTranslations.textEnterValidVinError}}
                    }
                  </div>
                </div>
              }
              @if (!this.isLeadSeller || this.isLeadSellerDealerChosen(this.vinPostingForm)) {
                <button
                  #vinSubmitButton
                  type="submit"
                  data-track-elem="button"
                  [ngClass]="this.isLeadSeller? 'btn btn-primary post-btn lead-seller-button' : 'btn btn-primary post-btn'"
                  allytmln="postButton"
                  >
                  <span>{{newPostTranslations.textPostButton}}</span>
                </button>
              }
            </form>
          </div>
        </ng-container>
      </ng-template>

      <!-- Third Party post -->
      <ng-template #tmplThirdPartyPost>
        <div class="third-party-posting-container">
          <form [formGroup]="thirdPartyPostingForm"
            (ngSubmit)="thirdPartyPostingForm.valid && findThirdPartyData(thirdPartyTargetVin)"
            id="vin-third-party-post-form"
            aria-hidden="false"
            >

            @if (this.isLeadSeller) {
              <div class="input-container">
                @if (this.selectedDealership === undefined && this.isDeepLink) {
                  <p class="pt-4">{{newPostTranslations.selectDealer}}</p>
                }
                <div class="form-group">
                  <label for="leadSellerDealershipSelection" class="label">{{newPostTranslations.dealershipsLabel}}</label>
                  <div class="select-wrapper">
                    <select #thirdPartyPostDealershipSelect formControlName="leadSellerDealershipSelection" id="leadSellerDealershipSelection" class="custom-select wrapText leadDealerSelect">
                      <option [ngValue]="'default'">{{newPostTranslations.select}}</option>
                      @for (dealership of dealershipOptions; track dealership) {
                        <option [ngValue]="dealership.oeUuid">{{dealership.oeName}}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (this.isDealershipOptionsEmpty) {
                  <span class="required-item-error-message">
                    {{newPostTranslations.noDealershipsFoundMessage}}
                  </span>
                }
              </div>
            }

            @if (!this.isLeadSeller || this.isLeadSellerDealerChosen(this.thirdPartyPostingForm)) {
              <div
                [ngClass]="this.isLeadSeller? 'input-container lead-seller-style' : 'input-container'">
                <input
                  formControlName="vin"
                  id="search-by-vin"
                  type="text"
                  maxlength="17"
                  minLength="6"
                  placeholder="{{thirdPartyPostTranslations.textThirdPartyPostVinPlaceHolder}}"
                  class="italic-placeholder form-control"
                  [class.invalid]="thirdPartyPostingForm.get('vin').errors"
                  aria-labelledby="search-by-vin__label"
                  aria-describedby="search-by-vin__description"
                  />
                <div class="text-danger" aria-live="polite" aria-atomic="true" role="alert" id="search-by-vin__error">
                  @if (thirdPartyPostingForm.get('vin').errors) {
                    {{thirdPartyPostTranslations.textEnterValidVinError}}
                  }
                </div>
              </div>
            }
            <div>
              @if (!this.isLeadSeller || this.isLeadSellerDealerChosen(this.thirdPartyPostingForm)) {
                <button
                  type="submit"
                  data-track-elem="button"
                  [ngClass]="this.isLeadSeller ? 'btn btn-primary search-btn lead-seller-button' : 'btn btn-primary search-btn'"
                  allytmln="searchButton"
                  >
                  <span>{{thirdPartyPostTranslations.textThirdPartyPostSearchButton}}</span>
                </button>
              }
            </div>
          </form>
        </div>
      </ng-template>
      <!--      TPP Search Results -->
      @if (showThirdPartyResultSection) {
        <div class="tpp-search-results mt-4">
          <div class="search-results-header mb-4" aria-hidden="false">
            <h2 class="mb-0">
              {{ textResults }}
            </h2>
            <div class="search-results-divider"></div>
          </div>
          <section class="row">
            <div class="col-lg-12">
              <section class="third-party-posting-table">
                @if (showSpinner && !thirdPartySearchResults) {
                  <lib-posting-skeleton></lib-posting-skeleton>
                }
                @if (thirdPartySearchResults) {
                  <app-third-party-posting-search-results
                    [thirdPartySearchResults]="thirdPartySearchResults"
                    (proceedWithThirdPartyVin)="beginThirdPartyPosting($event)"
                  ></app-third-party-posting-search-results>
                }
              </section>
            </div>
          </section>
        </div>
      }
    </div>
  </div>
  <app-new-posting-modal
    [isLoading]="showSpinner"
    [decodedDetails]="vinDecodeVehicleInformation"
    [errorHeaderKey]="errorHeaderKey"
    [errorMessageKey]="errorMessageKey"
    [inspectionFetched]="inspectionFetched"
    [existingInspectionReport]="existingInspectionReport"
    [availableInspectionActions]="translatedInspectionActions"
    [vin]="targetVin"
    [thirdPartyPostingRequest]="activeTab === postingTabs.THIRD_PARTY_POST"
    (modalClosed)="handleModalClose()"
    (getInspections)="getInspectionReports()"
    (getChromeOptions)="getChromeVehicleData($event)"
    >
  </app-new-posting-modal>
</ng-container>
